import { parseDecimalPlaces, parseThousand } from 'utils/parser.utils';

import rmv from 'assets/wheel-of-fortune/rmv.png';
import vipPoint from 'assets/vip_point.png';

import { RewardKind } from '../WheelOfFortune/types';
import RoundedRow from './RoundedRow';

/**
 * `wof` is not a prize kind — it is the credit side of the ledger, where the row records
 * spins being ADDED to a balance rather than a prize being won. Everything else is a
 * RewardKind, so a wheel that pays lootboxes or NFTs can be described here too.
 */
type RewardRowType = RewardKind | 'wof';

type RewardRowProps = {
  reward: string | undefined;
  rewardType?: RewardRowType;
};

/** Suffix for counted prizes; RMV and VIP points read as bare numbers beside their icon. */
const COUNTED_LABEL: Partial<Record<RewardRowType, [string, string]>> = {
  wof: ['WoF Spin', 'WoF Spins'],
  wof_spins: ['Spin', 'Spins'],
  vip_wof_spins: ['VIP Spin', 'VIP Spins'],
  lootbox: ['Lootbox', 'Lootboxes'],
  nft: ['NFT', 'NFTs'],
};

const RewardRow = ({ reward, rewardType = 'rmv' }: RewardRowProps) => {
  const getValue = () => {
    if (!reward) return '-';

    const counted = COUNTED_LABEL[rewardType];
    if (counted) {
      const [singular, plural] = counted;
      return `${reward} ${reward === '1' ? singular : plural}`;
    }

    if (rewardType === 'vip_points') {
      return reward;
    }

    const cleanedValue = parseDecimalPlaces(reward);
    const formattedValue = parseThousand(parseFloat(cleanedValue));
    return formattedValue;
  };

  const icon = rewardType === 'vip_points' ? vipPoint : rmv;
  const showIcon = rewardType === 'rmv' || rewardType === 'vip_points';

  return (
    <RoundedRow>
      <div className="tw-flex tw-items-center tw-justify-center tw-gap-[2px] tw-px-[10px] tw-py-[10px] tw-text-center tw-text-[8px] tw-font-bold tw-text-white lg:tw-gap-2 lg:tw-text-[18px]">
        {showIcon && (
          <img src={icon} alt={rewardType === 'vip_points' ? 'vip' : 'rmv'} className="tw-h-[12px] tw-w-[12px] lg:tw-h-[15px] lg:tw-w-[15px]" />
        )}
        {getValue()}
      </div>
    </RoundedRow>
  );
};

export default RewardRow;
